var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.analysis
    ? _c(
        "div",
        [
          !_vm.analysis.isReadOnly
            ? _c("bootstrap-box", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function() {
                        return [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary pull-right",
                              on: {
                                click: function($event) {
                                  _vm.displayFinalizePrompt = true
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.resource("Button_Finalize")) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary pull-right mr-3",
                              on: { click: _vm.saveAnswers }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.resource("Button_Save")) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  1950522267
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.analysis.labels, function(label) {
            return _c("bootstrap-box", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "body",
                    fn: function() {
                      return [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-2 fields ucid" },
                            [
                              _vm._l(label.startUcid, function(value, name) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(name) + ": " + _vm._s(value))
                                  ])
                                ]
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-4" },
                            _vm._l(label.paths, function(pathCollection) {
                              return _c(
                                "div",
                                { staticClass: "pathcollection" },
                                [
                                  _vm._l(pathCollection, function(path) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "fields" },
                                        [
                                          _vm._l(path, function(value, name) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(name) +
                                                    ": " +
                                                    _vm._s(value)
                                                )
                                              ])
                                            ]
                                          })
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      path !== pathCollection.at(-1)
                                        ? _c("i", {
                                            staticClass:
                                              "fas fa-arrow-right mt-auto mb-auto"
                                          })
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-2 fields ucid" },
                            [
                              _vm._l(label.endUcid, function(value, name) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(name) + ": " + _vm._s(value))
                                  ])
                                ]
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-4" },
                            _vm._l(label.answers, function(answer) {
                              return _c("question", {
                                staticClass: "form-group",
                                attrs: {
                                  question:
                                    _vm.questionLookup[answer.questionId],
                                  readonly: _vm.analysis.isReadOnly
                                },
                                model: {
                                  value: answer.value,
                                  callback: function($$v) {
                                    _vm.$set(answer, "value", $$v)
                                  },
                                  expression: "answer.value"
                                }
                              })
                            }),
                            1
                          )
                        ])
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                true
              )
            })
          }),
          _vm._v(" "),
          !_vm.analysis.isReadOnly
            ? _c("bootstrap-box", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "body",
                      fn: function() {
                        return [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary pull-right",
                              on: {
                                click: function($event) {
                                  _vm.displayFinalizePrompt = true
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.resource("Button_Finalize")) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary pull-right mr-3",
                              on: { click: _vm.saveAnswers }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.resource("Button_Save")) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  1950522267
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.displayFinalizePrompt
            ? _c(
                "prompt",
                _vm._b(
                  {
                    on: {
                      yes: _vm.finish,
                      hidden: function($event) {
                        _vm.displayFinalizePrompt = false
                      }
                    }
                  },
                  "prompt",
                  _vm.finalizePrompt,
                  false
                )
              )
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }